import type { IComponentController, IScope } from "angular";

import { finalize } from "rxjs/operators";

import type { IConfigurationGroup, IConfigurationGroupReporting, IResponseWithLoading } from "App/Modules/Models";
import type { ISitesRepository } from "App/Modules/Repositories";
import type { IModalService } from "App/Modules/Services";
import { extendWithLoadingAndFail } from "App/Modules/Services";

export default class SiteConfigurationGroupReportingComponentController implements IComponentController {
    public static $inject: string[] = ["$scope", "mmModalService", "mmSitesRepository"];

    public configurationGroup: IConfigurationGroup;

    public configurationGroupReporting: IResponseWithLoading<IConfigurationGroupReporting>;

    public deleted: (params: { id: string }) => void;

    constructor(
        private readonly $scope: IScope,
        private readonly modalService: IModalService,
        private readonly sitesRepository: ISitesRepository,
    ) {}

    public $onInit() {
        extendWithLoadingAndFail(
            this.sitesRepository.getConfigurationGroupReporting(
                this.configurationGroup.siteId,
                this.configurationGroup.id,
            ),
        )
            .pipe(finalize(() => this.$scope.$applyAsync()))
            .subscribe(
                (result) => {
                    this.configurationGroupReporting = result;
                },
                (result) => {
                    this.configurationGroupReporting = result;
                },
            );
    }

    public editConfiguration() {
        this.modalService
            .open<IConfigurationGroupReporting, void>(
                "mmConfigurationGroupReportingEdit",
                this.configurationGroupReporting.data,
                null,
                "lg",
            )
            .subscribe(
                (editedConfiguration) => {
                    if (editedConfiguration !== null) {
                        this.configurationGroupReporting.data = editedConfiguration;
                        this.configurationGroup.name = editedConfiguration.name;
                    } else {
                        this.deleted({ id: this.configurationGroup.id });
                    }
                },
                (reason) => reason,
            );
    }
}
